import axios from "../index";
import api from "./personalSpace.api";

export default {
    // 课程实训接口
    /**
     * 查询课程实训下我的项目列表  @data {"dictTypeCode": "ProjectType"} 字典类型编码
     */
    getComDictionary(data = {}) {
        return axios.post(api.getComDictionary, data);
    },
    /**
     * 获取编辑器类型字典  
     * @data {"dictTypeCode": "EditorType"}
     * @return  array
     */
     getEditorDictionary(data = {}) {
        return axios.post(api.getEditorDictionary, data);
    },
    /**
     * 查询课程实训下我的项目列表  @data  proOperate 0个人 1公开；userId 当前登录人id   "pageNum": 1,"pageSize": 10, 分页字段  editorId 编辑器id
     */
    getProjectListByUserId(data = {}) {
        return axios.post(api.getProjectListByUserId, data);
    },
    /**
     * 新增个人空间项目数据  @data projectContent 项目简介 ；projectId 项目id projectName 项目名称 projectType 项目类型
     */
    insertProjectByUserId(data = {}) {
        return axios.post(api.insertProjectByUserId, data);
    },
    /**
     * 删除个人空间项目数据  @data projectId 项目id 
     */
    deleteProjectByProjectId(data = {}) {
        return axios.post(api.deleteProjectByProjectId, data);
    },
    /**
     * 修改个人空间项目数据  @data 
     * {
  "projectContent": "string",
  "projectId": "string",
  "projectName": "string",
  "projectType": "string"
}
     */
    updateProjectByProjectId(data = {}) {
        return axios.post(api.updateProjectByProjectId, data);
    },
 
    /**
     * 获取个人空间项目详情数据  @data projectId
     */
    getProjectByProjectId(data = {}) {
        return axios.post(api.getProjectByProjectId, data);
    },
    /**
     * 保存项目代码  @data buildingBlocks 项目积木;  projectId 项目id
     */
    saveProjectCode(data = {}) {
        return axios.post(api.saveProjectCode, data);
    },
    /**
     * 保存python编辑器的项目代码  @data pythonCode python脚本;  projectId 项目id
     */
     savePythonProjectCode(data = {}) {
        return axios.post(api.savePythonProjectCode, data);
    },
    /**
     * 公开个人空间项目数据  @data proOperate 项目属性：0：个人；1：公开；   projectId 项目id 
     */
    openProjectByProjectId(data = {}) {
        return axios.post(api.openProjectByProjectId, data);
    },
 
};